module["exports"] = [
  "Azərbaycan"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/address/default_country.js
// module id = 164
// module chunks = 0